import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="regulatory_updates" />;

export const Route = createFileRoute("/zh-cn/regulatory-updates/$slug")({
  loader: ({ params }) => loadContentMeta("regulatory_updates", params.slug, "zh-cn"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/regulatory-updates/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

